export const docMenus = [
  {
    id: 4,
    name: '合同协同起草',
    icon: 'el-icon-s-claim',
    url: '/smartDoc/docDraft/draftList',
  },
  {
    id: 2,
    name: '法律风险审核',
    icon: 'el-icon-s-check',
    url: '/smartDoc/docExamine/examineList',
  },
  {
    id: 3,
    name: '合同关键词抽取',
    icon: 'el-icon-s-order',
    url: '/smartDoc/docExtract/extractList',
  },
  {
    id: 1,
    name: '智能文档对比',
    icon: 'el-icon-s-cooperation',
    url: '/smartDoc/docContrast/contrastList',
  },
]
/** 
 * 1225需求 更改了路由列表
 * auther:yilixing
 * date:2023/01/04
 * */ 
// export const docMenus = [
//   {
//     id: 1,
//     name: '文档比对',
//     icon: 'el-icon-s-cooperation',
//     url: '/smartDoc/docContrast',
//     children: [
//       {
//         id: 101,
//         name: '智能文档比对',
//         icon: '/images/AISmart/icon/contrast.png',
//         url: '/smartDoc/docContrast/contrast'
//       },
//       {
//         id: 102,
//         name: '文档比对列表',
//         icon: '/images/AISmart/icon/listShape.png',
//         url: '/smartDoc/docContrast/contrastList'
//       }
//     ]
//   },
//   {
//     id: 2,
//     name: '文档审核',
//     icon: 'el-icon-s-check',
//     url: '/smartDoc/docExamine',
//     children: [
//       {
//         id: 201,
//         name: '智能文档审核',
//         icon: '/images/AISmart/icon/toExamine.png',
//         url: '/smartDoc/docExamine/examine'
//       },
//       {
//         id: 202,
//         name: '文档审核列表',
//         icon: '/images/AISmart/icon/examine.png',
//         url: '/smartDoc/docExamine/examineList'
//       }
//     ]
//   },
//   {
//     id: 3,
//     name: '文档抽取',
//     icon: 'el-icon-s-order',
//     url: '/smartDoc/docExtract',
//     children: [
//       {
//         id: 301,
//         name: '智能文档抽取',
//         icon: '/images/AISmart/icon/extract.png',
//         url: '/smartDoc/docExtract/extract'
//       },
//       {
//         id: 302,
//         name: '文档抽取列表',
//         icon: '/images/AISmart/icon/list.png',
//         url: '/smartDoc/docExtract/extractList'
//       }
//     ]
//   },
//   {
//     id: 4,
//     name: '合同起草',
//     icon: 'el-icon-s-claim',
//     url: '/smartDoc/docDraft',
//     children: [
//       {
//         id: 401,
//         name: '模板起草',
//         icon: '/images/AISmart/icon/draft.png',
//         url: '/smartDoc/docDraft/draft'
//       },
//       {
//         id: 402,
//         name: '合同起草列表',
//         icon: '/images/AISmart/icon/upload.png',
//         url: '/smartDoc/docDraft/draftList'
//       }
//     ]
//   }
// ]


// WEBPACK FOOTER //
// ./assets/js/utils/docMenu.js